enum LocalizationCallStatus {
    Inactive = "CallCenter_CallStatus_Inactive",
    Active = "CallCenter_CallStatus_Active",
    OnHold = "CallCenter_CallStatus_OnHold"
}

enum IconClassNameCall {
    Inactive = "circleStatusInactive",
    Active = "circleStatusActive",
    OnHold = "circleStatusOnHold"
}

enum RecallStatusTypeLookup {
    Code = "RecallStatusType",
    OutgoingCall = "OutgoingCall",
    IncomingCall = "IncomingCall"
}

export {
    IconClassNameCall,
    LocalizationCallStatus,
    RecallStatusTypeLookup
};
